<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block">
		<span class="card-title-label" translate>home.order-tracking.orders</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input
				[placeholder]="'search.placeholder' | translate"
				matInput
				type="text"
				spellcheck="false"
				autocomplete="off"
				[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');" tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<ng-container *ngIf="!isLoading else loading">
		<div class="grid-6 copo-container footer-margin" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller" (moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
			<div *ngFor="let order of scroller.list" class="grid-column-one-full card-block">
				<div class="card-portal">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
							<span class="header-margin-right">{{ getOrderName(order) }}</span>
							<div class="card-container-column header-margin-right">
								<span class="card-header-label" translate>order.mill</span>
								<span>{{ order.millDescription ? order.millDescription : UNDERSCORE }}</span>
							</div>
							<div class="card-container-column header-margin-right">
								<span class="card-header-label" translate>order-tracking.steelgrade</span>
								<span>{{ order.steelgradeDescription ? order.steelgradeDescription : UNDERSCORE }}</span>
							</div>
							<div class="card-container-column header-margin-right">
								<span class="card-header-label" translate>order-tracking.dimension</span>
								<span>{{ order | copoDimension }}</span>
							</div>
							<div class="card-container-column header-margin-right">
								<span class="card-header-label" translate>order-tracking.customerArticleReference</span>
								<span>{{ order.customerArticleReference ? order.customerArticleReference : UNDERSCORE }}</span>
							</div>
						</div>
						<div class="card-header-right">
							<button type="button" *ngIf="order.isFavorite" [disabled]="order.isFavoriteDisabled" mat-icon-button
								(click)="deleteFavoriteOrder(order)">
								<mat-icon svgIcon="md:star"></mat-icon>
							</button>
	
							<button type="button" *ngIf="!order.isFavorite" [disabled]="order.isFavoriteDisabled" mat-icon-button
								(click)="saveFavoriteOrder(order)">
								<mat-icon svgIcon="md:star_border"></mat-icon>
							</button>
						</div>
					</div>
					<div class="card-content">
						<div class="card-container-column ">
							<div class="container-ordered">
								<span class="tag-tonnage">{{ getQuantity(order, 'ordered') | copoNumber:'weight':'t' }}</span>
							</div>
							
							<div class="card-container-column">
								<span class="card-content-label" translate>order-tracking.cdd</span>
								<span>{{ checkCddWeekData(order) }}</span>
							</div>
						</div>
						<div class="card-container-column card-column-end">
							<span class="card-content-label" translate>order.first.batch.in.stock</span>
							<span>{{ order.grossFirstBatchInStock ? (order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
						</div>
						<div class="card-container-column card-column-end">
							<span class="card-content-label" translate>order.last.batch.in.stock</span>
							<span>{{ order.grossLastBatchInStock ? (order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
						</div>
						<div class="card-container-column card-column-center">
							<mat-icon class="card-icon-tonnage" svgIcon="in_production"></mat-icon>
							<div class="card-container-column card-column-center">
								<span class="card-content-label" translate>order-tracking.in.production</span>
								<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'inProduction') | copoNumber:'weight':'t' }}</span>
							</div>
						</div>
						<div class="card-container-column card-column-center">
							<mat-icon class="card-icon-tonnage" svgIcon="in_stock"></mat-icon>
							<div class="card-container-column card-column-center">
								<span class="card-content-label" translate>order-tracking.in.stock</span>
								<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'readyToShip') | copoNumber:'weight':'t' }}</span>
							</div>
						</div>
						<div class="card-container-column card-column-center">
							<mat-icon class="card-icon-tonnage" svgIcon="in_transit"></mat-icon>
							<div class="card-container-column card-column-center">
								<span class="card-content-label" translate>order-tracking.in.transit</span>
								<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'inTransit') | copoNumber:'weight':'t' }}</span>
							</div>
						</div>
						<div class="card-container-column card-column-center">
							<mat-icon class="card-icon-tonnage" svgIcon="delivered"></mat-icon>
							<div class="card-container-column card-column-center">
								<span class="card-content-label" translate>order-tracking.delivered</span>
								<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'delivered') | copoNumber:'weight':'t' }}</span>
							</div>
						</div>
						<div class="card-container-column card-column-around">
							<a mat-button color="primary" class="card-container-link" [routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]" fragment="documents">
								<span translate>order-card.commercial-documents</span>
								<mat-icon iconPositionEnd color="accent" svgIcon="table_document"></mat-icon>
							</a>
							<div class="card-container-link">
								<a mat-button color="primary" [routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]">
									<span translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="card-mobile">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
							<span class="header-margin-right overflow-wrap">{{ getOrderName(order) }}</span>
						</div>
						<div>
							<span class="tag-tonnage">{{ getQuantity(order, 'ordered') | copoNumber:'weight':'t' }}</span>
						</div>
						<div class="card-header-right">
							<button type="button" *ngIf="order.isFavorite" [disabled]="order.isFavoriteDisabled" mat-icon-button
								(click)="deleteFavoriteOrder(order)">
								<mat-icon svgIcon="md:star"></mat-icon>
							</button>
	
							<button type="button" *ngIf="!order.isFavorite" [disabled]="order.isFavoriteDisabled" mat-icon-button
								(click)="saveFavoriteOrder(order)">
								<mat-icon svgIcon="md:star_border"></mat-icon>
							</button>
						</div>
					</div>
					<div class="card-content">
						<div class="content-grid-mobile">
							<div class="card-container-column">
								<span class="card-content-label" translate>order-tracking.steelgrade</span>
								<span class="overflow-wrap">{{ order.steelgradeDescription ? order.steelgradeDescription : UNDERSCORE }}</span>
							</div>
							<div class="card-container-column">
								<span class="card-content-label" translate>order-tracking.dimension</span>
								<span class="overflow-wrap">{{ order | copoDimension }}</span>
							</div>
							<div class="card-container-column ">
								<div class="card-container-column">
									<span class="card-content-label" translate>order-tracking.cdd</span>
									<span class="overflow-wrap">{{ checkCddWeekData(order) }}</span>
								</div>
							</div>
							<div class="card-container-column card-column-end">
								<span class="card-content-label" translate>order.mill</span>
								<span>{{ order.millDescription ? order.millDescription : UNDERSCORE }}</span>
							</div>
						</div>
						<div class="container-quantities-mobile">
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_production"></mat-icon>
								<div class="card-container-column card-column-center">
									<span class="card-content-label" translate>order-tracking.in.production</span>
									<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'inProduction') | copoNumber:'weight':'t' }}</span>
								</div>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_stock"></mat-icon>
								<div class="card-container-column card-column-center">
									<span class="card-content-label" translate>order-tracking.in.stock</span>
									<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'readyToShip') | copoNumber:'weight':'t' }}</span>
								</div>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="in_transit"></mat-icon>
								<div class="card-container-column card-column-center">
									<span class="card-content-label" translate>order-tracking.in.transit</span>
									<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'inTransit') | copoNumber:'weight':'t' }}</span>
								</div>
							</div>
							<div class="card-container-column card-column-center">
								<mat-icon class="card-icon-tonnage" svgIcon="delivered"></mat-icon>
								<div class="card-container-column card-column-center">
									<span class="card-content-label" translate>order-tracking.delivered</span>
									<span class="order-weight-label label-orange-color">{{ getQuantity(order, 'delivered') | copoNumber:'weight':'t' }}</span>
								</div>
							</div>
						</div>
						<div class="card-container-column card-column-around">
							<div class="card-container-link">
								<a mat-button color="primary" [routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]">
									<span translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full" *ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>